if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.activeMediaIndex = 0;
        this.touchStartX = 0;
        this.touchStartY = 0;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.setupMediaNavigation();
        this.showActiveMedia();
      }

      getMediaContainer() {
        return this.querySelector('[role="document"]');
      }

      getMediaItems() {
        const container = this.getMediaContainer();
        if (!container) return [];

        return Array.from(container.querySelectorAll('[data-media-id]'));
      }

      setupMediaNavigation() {
        if (this.dataset.icNavigationReady === 'true') return;
        this.dataset.icNavigationReady = 'true';

        const container = this.getMediaContainer();
        const prevButton = this.querySelector('[data-ic-prev]');
        const nextButton = this.querySelector('[data-ic-next]');

        if (prevButton) {
          prevButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.showMediaByIndex(this.activeMediaIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.showMediaByIndex(this.activeMediaIndex + 1);
          });
        }

        if (container) {
          container.addEventListener(
            'touchstart',
            (event) => {
              this.touchStartX = event.changedTouches[0].screenX;
              this.touchStartY = event.changedTouches[0].screenY;
            },
            { passive: true }
          );

          container.addEventListener(
            'touchend',
            (event) => {
              const touchEndX = event.changedTouches[0].screenX;
              const touchEndY = event.changedTouches[0].screenY;
              const distanceX = this.touchStartX - touchEndX;
              const distanceY = this.touchStartY - touchEndY;

              if (Math.abs(distanceX) < 45 || Math.abs(distanceX) < Math.abs(distanceY)) return;

              if (distanceX > 0) {
                this.showMediaByIndex(this.activeMediaIndex + 1);
              } else {
                this.showMediaByIndex(this.activeMediaIndex - 1);
              }
            },
            { passive: true }
          );
        }

        document.addEventListener('keydown', (event) => {
          if (!this.classList.contains('active')) return;
          if (event.key === 'ArrowLeft') this.showMediaByIndex(this.activeMediaIndex - 1);
          if (event.key === 'ArrowRight') this.showMediaByIndex(this.activeMediaIndex + 1);
        });
      }

      normalizeMediaId(value) {
        if (!value) return '';
        return String(value).split('-').pop();
      }

      showActiveMedia() {
        const openedMediaId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : '';
        const openedId = this.normalizeMediaId(openedMediaId);
        const mediaItems = this.getMediaItems();

        if (!mediaItems.length) return;

        const activeIndex = mediaItems.findIndex((element) => {
          return this.normalizeMediaId(element.getAttribute('data-media-id')) === openedId;
        });

        this.showMediaByIndex(activeIndex >= 0 ? activeIndex : 0);
      }

      showMediaByIndex(index) {
        const mediaItems = this.getMediaItems();

        if (!mediaItems.length) return;

        this.activeMediaIndex = (index + mediaItems.length) % mediaItems.length;
        const activeMedia = mediaItems[this.activeMediaIndex];

        mediaItems.forEach((element) => {
          element.classList.remove('active');
        });

        activeMedia.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
